import {BaseApiTemplateService, Core2Config} from '../../shared';

import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {WfIssueContainerModel} from "../../../../../../models/aggregates/wf/issue";

@Injectable({providedIn: 'root'})
export class WfIssueService extends BaseApiTemplateService<WfIssueContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'issues';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'issues';
    this.httpClient = http;
  }
}
